/**
 * TypingIndicator
 *
 * Shows "X is typing..." with animated dots.
 * Uses the conversation.typing map to determine who's typing.
 */

export default function TypingIndicator({ typing, currentUserId, participants }) {
  if (!typing || typeof typing !== 'object') return null;

  // Get users who are currently typing (exclude self)
  // Consider "typing" if timestamp is within last 10 seconds
  const now = Date.now();
  const typingUsers = Object.entries(typing)
    .filter(([userId, timestamp]) => {
      if (userId === currentUserId) return false;
      if (!timestamp) return false;
      // Timestamp could be a Firestore Timestamp or Date
      const ts = timestamp?.toDate?.() || timestamp?.seconds ? new Date(timestamp.seconds * 1000) : null;
      if (!ts) return false;
      return (now - ts.getTime()) < 10000; // Within 10 seconds
    })
    .map(([userId]) => {
      const participant = participants?.find(p => p.userId === userId);
      return participant?.name?.split(' ')[0] || 'Someone';
    });

  if (typingUsers.length === 0) return null;

  const text = typingUsers.length === 1
    ? `${typingUsers[0]} is typing`
    : typingUsers.length === 2
      ? `${typingUsers[0]} and ${typingUsers[1]} are typing`
      : `${typingUsers[0]} and ${typingUsers.length - 1} others are typing`;

  return (
    <div className="px-4 py-1">
      <span className="text-xs text-base-content/50 italic">
        {text}
        <span className="inline-flex ml-0.5">
          <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
        </span>
      </span>
    </div>
  );
}
